import { render, staticRenderFns } from "./PortalCompanyList.vue?vue&type=template&id=9559bbc6&"
import script from "./PortalCompanyList.vue?vue&type=script&lang=js&"
export * from "./PortalCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports